import { c as _c } from "react/compiler-runtime";
import * as Colors from "../../utils/helpers/ColorCodes";
import { ColorWheelSVG } from "./FilterSVGs";
const BubbleComponents = ({
  stateValues,
  updateState,
  filterType = null
}) => {
  const renderValues = value => {
    let updatedvalue = value;
    if (filterType == "cylinder") {
      updatedvalue = typeof value === "string" && value.includes(" ") ? value.split(" ")[0] : value;
    } else if (filterType == "driveType") {
      let driveTrain = value.split(" ");
      if (driveTrain.length == 3) {
        if (driveTrain[0] == "Four") {
          updatedvalue = "4" + driveTrain[1][0] + driveTrain[2][0];
        } else {
          updatedvalue = driveTrain[0][0] + driveTrain[1][0] + driveTrain[2][0];
        }
      } else if (driveTrain.length == 1) {
        updatedvalue = value;
      }
    } else if (filterType == "engine") {
      if (value != "Other") {
        updatedvalue = value + "L";
      }
    }
    return updatedvalue;
  };
  const RemoveItem = value => {
    updateState(stateValues.filter(item => item !== value));
  };
  return stateValues.map((currentItem, index) => <span className='ms-1 span-item mt-2' onClick={() => RemoveItem(currentItem)} key={index}>
            {renderValues(currentItem)}
            <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M3 13L13 3' stroke='#ABAEBC' strokeWidth='2' strokeLinecap='round' />
                <path d='M3 3L13 13' stroke='#ABAEBC' strokeWidth='2' strokeLinecap='round' />
            </svg>
        </span>);
};
function FilterBubbles(props) {
  const $ = _c(64);
  let t0;
  if ($[0] !== props) {
    t0 = value => {
      props.updateModel(props.model.filter(item => item.value !== value.value));
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const RemoveModel = t0;
  let t1;
  if ($[2] !== props) {
    t1 = value_0 => {
      const updatedMake = props.make.filter(item_0 => item_0.value !== value_0.value);
      props.updateMake(updatedMake);
      props.updateAvailableModelsDropdown(updatedMake);
      const matchedModel = props.allModels.find(obj => obj.label === value_0.value);
      props.updateModel(props.model.filter(item_1 => !matchedModel.options.some(secondItem => secondItem.label === item_1.label)));
    };
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const RemoveMake = t1;
  const RemoveColor = _temp;
  let t2;
  if ($[4] !== props) {
    t2 = !!props.AnyFilterSelected() && <span className="ms-1 span-item mt-2" onClick={() => {
      props.ClearAllStates();
      if (props.ClearMobileFilters) {
        props.ClearMobileFilters();
      }
    }}>Clear All</span>;
    $[4] = props;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== RemoveMake || $[7] !== props.make) {
    t3 = props?.make.map((currentItem, index) => <span className="ms-1 span-item mt-2" onClick={() => RemoveMake(currentItem)} key={index}>{currentItem?.value}<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 13L13 3" stroke="#ABAEBC" strokeWidth="2" strokeLinecap="round" /><path d="M3 3L13 13" stroke="#ABAEBC" strokeWidth="2" strokeLinecap="round" /></svg></span>);
    $[6] = RemoveMake;
    $[7] = props.make;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== RemoveModel || $[10] !== props.model) {
    t4 = props?.model.map((currentItem_0, index_0) => <span className="ms-1 span-item mt-2" onClick={() => RemoveModel(currentItem_0)} key={index_0}>{currentItem_0?.value}<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 13L13 3" stroke="#ABAEBC" strokeWidth="2" strokeLinecap="round" /><path d="M3 3L13 13" stroke="#ABAEBC" strokeWidth="2" strokeLinecap="round" /></svg></span>);
    $[9] = RemoveModel;
    $[10] = props.model;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== props) {
    t5 = !!props.yearValues[0] && props.yearValues[1] && (props.yearValues[0] != props.minYear || props.yearValues[1] != props.maxYear) && <span className="ms-1 span-item mt-2" onClick={() => props.setYearValues([props.minYear, props.maxYear])}>{`${props.yearValues[0]} - ${props.yearValues[1]}`}<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 13L13 3" stroke="#ABAEBC" strokeWidth="2" strokeLinecap="round" /><path d="M3 3L13 13" stroke="#ABAEBC" strokeWidth="2" strokeLinecap="round" /></svg></span>;
    $[12] = props;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== props) {
    t6 = props.mileageValues[0] !== undefined && props.mileageValues[1] !== undefined && (props.mileageValues[0] != props.minMileage || props.mileageValues[1] != props.maxMileage) && <span className="ms-1 span-item mt-2" onClick={() => props.setMileageValues([props.minMileage, props.maxMileage])}>{`${props.mileageValues[0].toLocaleString()} - ${props.mileageValues[1].toLocaleString()}`}<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 13L13 3" stroke="#ABAEBC" strokeWidth="2" strokeLinecap="round" /><path d="M3 3L13 13" stroke="#ABAEBC" strokeWidth="2" strokeLinecap="round" /></svg></span>;
    $[14] = props;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== props) {
    t7 = !!props.priceValues[0] && props.priceValues[1] && (props.priceValues[0] != props.minPrice || props.priceValues[1] != props.maxPrice) && <span className="ms-1 span-item mt-2" onClick={() => props.setPriceValues([props.minPrice, props.maxPrice])}>{`$${props.priceValues[0].toLocaleString()} - $${props.priceValues[1].toLocaleString()}`}<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 13L13 3" stroke="#ABAEBC" strokeWidth="2" strokeLinecap="round" /><path d="M3 3L13 13" stroke="#ABAEBC" strokeWidth="2" strokeLinecap="round" /></svg></span>;
    $[16] = props;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== props) {
    t8 = props.paymentValues != null && props.paymentValues[0] && props.paymentValues[1] && (props.paymentValues[0] != props.minPayment || props.paymentValues[1] != props.maxPayment) && <span className="ms-1 span-item mt-2" onClick={() => props.setPaymentValues([props.minPayment, props.maxPayment])}>{`$${props.paymentValues[0].toLocaleString()} - $${props.paymentValues[1].toLocaleString()}`}<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 13L13 3" stroke="#ABAEBC" strokeWidth="2" strokeLinecap="round" /><path d="M3 3L13 13" stroke="#ABAEBC" strokeWidth="2" strokeLinecap="round" /></svg></span>;
    $[18] = props;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== props.bodyStyles || $[21] !== props.updateBodyStyles) {
    t9 = props.bodyStyles && <BubbleComponents stateValues={props.bodyStyles} updateState={props.updateBodyStyles} filterType="bodyStyles" />;
    $[20] = props.bodyStyles;
    $[21] = props.updateBodyStyles;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== props.cylinder || $[24] !== props.updateCylinder) {
    t10 = props.cylinder && <BubbleComponents stateValues={props.cylinder} updateState={props.updateCylinder} filterType="cylinder" />;
    $[23] = props.cylinder;
    $[24] = props.updateCylinder;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== props.door || $[27] !== props.updateDoor) {
    t11 = props.door && <BubbleComponents stateValues={props.door} updateState={props.updateDoor} />;
    $[26] = props.door;
    $[27] = props.updateDoor;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== props.transmission || $[30] !== props.updateTransmission) {
    t12 = props.transmission && <BubbleComponents stateValues={props.transmission} updateState={props.updateTransmission} />;
    $[29] = props.transmission;
    $[30] = props.updateTransmission;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== props.interiorColors || $[33] !== props.setInteriorColors) {
    t13 = props?.interiorColors.map((currentItem_1, index_1) => <span className="ms-1 span-item mt-2" onClick={() => RemoveColor(currentItem_1, props.interiorColors, props.setInteriorColors)} key={index_1}>{currentItem_1 != "Other" && <span className="div-shade-color me-2" style={{
        backgroundColor: Colors.ReturnColorCode(Colors, currentItem_1) ? Colors.ReturnColorCode(Colors, currentItem_1) : "black"
      }}><span className="vis-hid">xd</span></span>}{currentItem_1 == "Other" && <div className="div-other-color me-2"><ColorWheelSVG /></div>}{`Int-${currentItem_1}`}<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 13L13 3" stroke="#ABAEBC" strokeWidth="2" strokeLinecap="round" /><path d="M3 3L13 13" stroke="#ABAEBC" strokeWidth="2" strokeLinecap="round" /></svg></span>);
    $[32] = props.interiorColors;
    $[33] = props.setInteriorColors;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== props.exteriorColors || $[36] !== props.setExteriorColors) {
    t14 = props?.exteriorColors.map((currentItem_2, index_2) => <span className="ms-1 span-item mt-2" onClick={() => RemoveColor(currentItem_2, props.exteriorColors, props.setExteriorColors)} key={index_2}>{currentItem_2 != "Other" && <span className="div-shade-color  me-2" style={{
        backgroundColor: Colors.ReturnColorCode(Colors, currentItem_2) ? Colors.ReturnColorCode(Colors, currentItem_2) : "black"
      }}><span className="vis-hid">xd</span></span>}{currentItem_2 == "Other" && <div className="div-other-color me-2"><ColorWheelSVG /></div>}{`Ext-${currentItem_2}`}<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 13L13 3" stroke="#ABAEBC" strokeWidth="2" strokeLinecap="round" /><path d="M3 3L13 13" stroke="#ABAEBC" strokeWidth="2" strokeLinecap="round" /></svg></span>);
    $[35] = props.exteriorColors;
    $[36] = props.setExteriorColors;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== props.fuel || $[39] !== props.updateFuel) {
    t15 = !!props.fuel && <BubbleComponents stateValues={props.fuel} updateState={props.updateFuel} />;
    $[38] = props.fuel;
    $[39] = props.updateFuel;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== props.train || $[42] !== props.updateTrain) {
    t16 = !!props.train && <BubbleComponents stateValues={props.train} updateState={props.updateTrain} filterType="driveType" />;
    $[41] = props.train;
    $[42] = props.updateTrain;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== props.engine || $[45] !== props.updateEngine) {
    t17 = !!props.engine && <BubbleComponents stateValues={props.engine} updateState={props.updateEngine} filterType="engine" />;
    $[44] = props.engine;
    $[45] = props.updateEngine;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  let t18;
  if ($[47] !== t10 || $[48] !== t11 || $[49] !== t12 || $[50] !== t13 || $[51] !== t14 || $[52] !== t15 || $[53] !== t16 || $[54] !== t17 || $[55] !== t2 || $[56] !== t3 || $[57] !== t4 || $[58] !== t5 || $[59] !== t6 || $[60] !== t7 || $[61] !== t8 || $[62] !== t9) {
    t18 = <div className="bubbles ps-2 ps-lg-0">{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}</div>;
    $[47] = t10;
    $[48] = t11;
    $[49] = t12;
    $[50] = t13;
    $[51] = t14;
    $[52] = t15;
    $[53] = t16;
    $[54] = t17;
    $[55] = t2;
    $[56] = t3;
    $[57] = t4;
    $[58] = t5;
    $[59] = t6;
    $[60] = t7;
    $[61] = t8;
    $[62] = t9;
    $[63] = t18;
  } else {
    t18 = $[63];
  }
  return t18;
}
function _temp(value_1, stateValues, updateState) {
  updateState(stateValues.filter(item_2 => item_2 !== value_1));
}
export default FilterBubbles;